<script setup>
  const { event } = defineProps({ event: Object });
</script>

<!----------------------------------------------------------------------------->

<template>
  <WatchCard :event="event" useBackground>
    <h2>
      <span>{{ useTournamentSize(event.size) }}</span> {{ event.tournament_title }}
    </h2>
  </WatchCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  h2 {
    @include title-l;
    font-size: px(120);

    @include break-large {
      font-size: px(100);
    }

    @include break-medium {
      font-size: 9vw;
    }

    @include break-small {
      text-align: center;
    }
  }
</style>
